export default __webpack_public_path__ + "static/media/KoRL_Hey.27903ed0.wav";